const IMX = ({ ...props }) => (
  <svg
    width="136"
    height="136"
    viewBox="0 0 136 136"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M115.12 19H127.698L76.6306 77.3586C75.3087 78.8058 75.2709 81.1135 76.5551 82.5998L106.017 116.864H92.8724L65.6392 85.1032L64.2794 83.3822C62.9952 81.8958 63.0329 79.588 64.3549 78.1408L115.12 19Z"
      fill="#17B5CB"
    />
    <path
      d="M86.7532 82.6389C85.9222 81.6611 85.6201 80.3312 85.9222 79.1186C86.1488 78.4537 86.6399 77.7105 87.0931 77.2021L90.4926 73.447L128 116.864H116.064C116.064 116.864 94.0809 91.2049 86.7532 82.6389Z"
      fill="#17B5CB"
    />
    <path
      d="M21.1067 116.864H8L48.1889 70.318C49.4731 68.8316 49.4731 66.6021 48.1889 65.1548L8.30217 19H20.9179L61.0312 65.5461C62.051 66.9151 62.2398 68.9099 61.1445 70.2006C50.644 82.3652 21.1067 116.864 21.1067 116.864Z"
      fill="#17B5CB"
    />
    <path
      d="M43.0896 19H30.965L68.1321 62.0648C68.1321 62.0648 68.2455 61.9866 72.4003 57.0973C73.5334 55.7674 73.76 54.1247 72.5136 52.873C64.6949 44.8546 43.0896 19 43.0896 19Z"
      fill="#17B5CB"
    />
    <path
      d="M79.2748 49.0398L105.073 19H92.8725L79.3881 34.724L75.4976 39.2612C74.1756 40.7085 74.1379 42.977 75.4221 44.5025C76.4042 45.6368 79.2748 49.0398 79.2748 49.0398Z"
      fill="#17B5CB"
    />
    <path
      d="M56.8767 86.8246L31.0787 116.864H43.2789L56.7633 101.14L60.6538 96.6031C61.9758 95.1559 62.0136 92.8873 60.7293 91.3619C59.7473 90.2275 56.8767 86.8246 56.8767 86.8246Z"
      fill="#17B5CB"
    />
  </svg>
);
export default IMX;
